// extracted by mini-css-extract-plugin
export default {"stats":"styles_stats__BoCrv","statSection":"styles_statSection__pi2py","sectionContainer":"styles_sectionContainer__HHXId"};